import { render } from "./NumberInfo.vue?vue&type=template&id=cf9c2260"
import script from "./NumberInfo.vue?vue&type=script&lang=js"
export * from "./NumberInfo.vue?vue&type=script&lang=js"

import "./NumberInfo.vue?vue&type=style&index=0&id=cf9c2260&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__